
(function () {
  var modal = document.getElementById("brainVideoModal");
  var player = document.getElementById("brainVideoPlayer");
  var embedWrap = document.getElementById("brainVideoEmbedWrap");
  var embed = document.getElementById("brainVideoEmbed");
  var closeEls = modal ? modal.querySelectorAll("[data-close-modal]") : [];

  function toEmbedUrl(url) {
    if (!url) return null;
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
    if (yt) return "https://www.youtube.com/embed/" + yt[1] + "?autoplay=1";
    var vim = url.match(/vimeo\.com\/(\d+)/);
    if (vim) return "https://player.vimeo.com/video/" + vim[1] + "?autoplay=1";
    if (/instagram\.com\/(reel|p)\//.test(url)) {
      return url.replace(/\/?$/, "/") + "embed";
    }
    return url;
  }

  function openModal(nativeSrc, externalUrl) {
    if (!modal || !player || !embed) return;

    player.style.display = "none";
    embedWrap.style.display = "none";
    try { player.pause(); } catch (e) {}
    player.src = "";
    embed.src = "";

    if (nativeSrc) {
      player.src = nativeSrc;
      player.style.display = "block";
      player.play().catch(function () {});
    } else if (externalUrl) {
      var embedUrl = toEmbedUrl(externalUrl);
      if (!embedUrl) return;
      embed.src = embedUrl;
      embedWrap.style.display = "block";
    } else {
      return;
    }

    modal.classList.add("is-active");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    if (!modal || !player || !embed) return;
    modal.classList.remove("is-active");
    document.body.style.overflow = "";
    try { player.pause(); } catch (e) {}
    try { player.currentTime = 0; } catch (e) {}
    player.src = "";
    embed.src = "";
  }

  function bindThumbs() {
    var thumbs = document.querySelectorAll(".brain-dr-initial-img");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var nativeSrc = thumb.getAttribute("data-video-native");
        var externalUrl = thumb.getAttribute("data-video-url");
        openModal(nativeSrc, externalUrl);
      });
    });
  }

  function bindClose() {
    closeEls.forEach(function (el) {
      el.addEventListener("click", closeModal);
    });
    if (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal) closeModal();
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal && modal.classList.contains("is-active")) {
        closeModal();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bindThumbs();
      bindClose();
    });
  } else {
    bindThumbs();
    bindClose();
  }
})();